import { render } from "./SaveCancelButtons.vue?vue&type=template&id=fac50d22&ts=true"
import script from "./SaveCancelButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./SaveCancelButtons.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/SaveCancelButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fac50d22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fac50d22', __exports__)) {
    console.log('reload')
    api.reload('fac50d22', __exports__)
  }
  
  module.hot.accept("./SaveCancelButtons.vue?vue&type=template&id=fac50d22&ts=true", () => {
    console.log('re-render')
    api.rerender('fac50d22', render)
  })

}


export default __exports__